import styles from './tabs.module.css'

export const generateButtonClasses = (isActive: boolean) => {
  return `${styles['menu-button']} ${isActive ? styles['menu-button-active'] : ''}`
}
